import {
  useUserStore,
  userStoreSelector,
} from '@repo/editor/src/stores/userStore';

import { useWorkspacesFeatureEnabled } from 'global/growthbookUtils';
import {
  useWorkspaceStore,
  workspaceStoreSelectors,
} from 'stores/workspaceStore';

/**
 * Returns the active workspace id.
 * If the workspaces feature is not enabled, it will return the personal workspace id.
 * If the workspaces feature is enabled, it will return the active workspace id.
 * If the fallbackToPersonal flag is true, it will return the personal workspace id if the active workspace id is not found (like on the pricing page)
 */
export const useActiveWorkspaceId = ({
  fallbackToPersonal = false,
}: {
  fallbackToPersonal?: boolean;
} = {}) => {
  const workspacesEnabled = useWorkspacesFeatureEnabled();
  const workspaceId = useWorkspaceStore(
    workspaceStoreSelectors.getActiveWorkspaceId
  );
  const user = useUserStore(userStoreSelector.user);
  const personalWorkspaceId = user?.personalWorkspaceId;

  if (!workspacesEnabled) {
    return personalWorkspaceId;
  }

  return workspaceId ?? (fallbackToPersonal ? personalWorkspaceId : undefined);
};
